import { Mol, Reaction } from '@moleculeone/types';
import { setPositions } from '@moleculeone/draw';
import { useMemo } from 'react';

import { BaseReaction } from '../../Reaction/BaseReaction';
import { calculateSeededPositions } from '../../../../utils';
import { REACTION_SIZE_SMALL } from '../../Reaction/utils/const';

declare const wasm_bindgen: any;

const MOL_CACHE: Record<string, Mol> = {};

const convertToMols = (smiles: string, smilesToMol: (smiles: string) => Mol) => {
  if (MOL_CACHE[smiles]) {
    return MOL_CACHE[smiles];
  }
  const mol = smilesToMol(smiles);
  const withPositions = setPositions(
    mol,
    calculateSeededPositions({
      mol,
      seedId: smiles,
    })
  );
  MOL_CACHE[smiles] = withPositions;
  return withPositions;
};

interface ReactionPreviewProps {
  reaction: Reaction;
  smilesToMol?: (smiles: string) => Mol;
}
export function ReactionPreview(props: ReactionPreviewProps) {
  const { reaction, smilesToMol } = props;

  const reactionMols = useMemo(() => {
    try {
      const toMol = smilesToMol ?? wasm_bindgen?.smilesToMol;
      const productMol = convertToMols(reaction.product, toMol);
      const substrateMols = reaction.substrates.map(substrate => convertToMols(substrate, toMol));

      return { productMol, substrateMols };
    } catch (error) {
      console.error('Error converting reaction to mols', error);
      return null;
    }
  }, [reaction, smilesToMol]);

  if (!reactionMols) {
    return null;
  }

  return (
    <BaseReaction
      size={REACTION_SIZE_SMALL}
      productMap={reaction.productMap}
      substratesMap={reaction.substratesMap}
      {...reactionMols}
    />
  );
}
